import React, { useEffect, useRef } from "react";
import logo from "./logo.jpg";
import {gsap} from "gsap";
import  "./homeStyle.css";

function Homepage(){
    const homePage = useRef(null);
    const ani1 = useRef(null);
    const ani2 = useRef(null);


   useEffect(()=>{
    let ctx = gsap.context(()=>{
        gsap.to(ani2.current, {
            duration: 1,
            ease: 'Power1.ease',
            
        })
        gsap.to(ani1.current, {
            duration: 1,
            ease: 'Power1.ease',
            xPercent:10,
        })
    })
    return()=> ctx.kill();
},[]);


return(
    <div className="Homepage" ref={homePage}>
        <h1 className="ani1" ref={ani1}>Welcome</h1>
        <img alt="logo" ref={ani2} className="ani2" src={logo}/>
    </div>
)
}


export default Homepage;